import { createFileRoute } from "@tanstack/react-router";
import {
    adoptionJourneyPageRoute,
    AdoptionJourneyPage,
} from "@/app-clients/adoption-journey-page";

export const Route = createFileRoute("/journey/$dogId")({
    ssr: adoptionJourneyPageRoute.ssr,
    loader: adoptionJourneyPageRoute.loader,
    head: adoptionJourneyPageRoute.head,
    pendingComponent: adoptionJourneyPageRoute.pendingComponent,
    component: AdoptionJourneyPage,
});
